import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearUserInfo } from '../store/userSlice';
import Navigation from '../components/Navigation';

function Login() {
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.user.userInfo);

    // User info is now fetched in App.js


    const handleLogout = () => {
        dispatch(clearUserInfo());
    };

    return (
        <div className="login-container">
            <Navigation />
            <div className="login-card">
                {userInfo ? (
                    <div className="user-info">
                        <h2>Welcome, {userInfo.userDetails}</h2>

                        {userInfo.userRoles && userInfo.userRoles.includes('admin') && (
                            <div className="code-block">
                                <pre>{JSON.stringify(userInfo, null, 2)}</pre>
                            </div>
                        )}

                        <a
                            href="/.auth/logout"
                            className="submit-button"
                            style={{ marginTop: '1rem' }}
                            onClick={handleLogout}
                        >
                            Logout
                        </a>
                    </div>
                ) : (
                    <>
                        <h2>Welcome</h2>
                        <p>Sign in to continue</p>
                        <a
                            href="/.auth/login/externalid"
                            className="submit-button"
                        >
                            Login
                        </a>
                    </>
                )}
            </div>
        </div>
    );
}

export default Login;
